import React, { useState, useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { setPin, removePin, downloadDoc } from '../../../../../services/documentsService';

import { RootState } from '../../../../../../redux/store';
import { PIN, POPUP } from '../../../../../../redux/types';

import { IActivityFeedCell } from '../../../../types/IActivityFeedCell';

import Pin from '../../../../../ui/button/pin/pin';
import Icon from '../../../../../ui/icon/icon';
import LoadingCell from '../../../../../ui/table/cells/loadingCell/loadingCell';

import './actionsCell.scss';

const ActionsCell: React.FC<IActivityFeedCell> = ({ dataItem }) => {
  const [isPinned, setIsPinned] = useState<boolean>(null);
  const [loading, setLoading] = useState<boolean>(false);

  const dispatch = useDispatch();

  const pins = useSelector((state: RootState) => state.pin.pins);
  const impersonate = useSelector((state: RootState) => state.impersonate);

  if (dataItem['documentId'] === undefined) return <LoadingCell />;

  useEffect(() => {
    setIsPinned(dataItem.isPinned);
  }, []);

  useEffect(() => {
    if (pins) {
      if (pins.includes(dataItem.assignId)) {
        setIsPinned(true);
      } else {
        setIsPinned(false);
      }
    }
  }, [pins, impersonate]);

  const handlePinClick = () => {
    if (loading) {
      return;
    }
    setLoading(true);
    if (isPinned === false) {
      setPin(parseInt(dataItem.assignId)).then(() => {
        setIsPinned(true);
        dispatch({ type: PIN.PIN_TRIGGER });
        setLoading(false);
      }).catch((err) => dispatch({ type: POPUP.SET_SERVER_ERROR, payload: err.message }));
    } else if (isPinned === true) {
      removePin(parseInt(dataItem.assignId)).then(() => {
        setIsPinned(false);
        dispatch({ type: PIN.PIN_TRIGGER });
        setLoading(false);
      }).catch((err) => dispatch({ type: POPUP.SET_SERVER_ERROR, payload: err.message }));
    }
  };

  return (
    <td className='document-cell pin-cell'>
      <div className='pin-cell-wrapper'>
        <Icon className='actions-cell-icon pointer' name='far fa-file-download'
              onClick={() => downloadDoc(dataItem).catch((err) => dispatch({
                type: POPUP.SET_SERVER_ERROR,
                payload: err.message,
              }))} />
        <Pin isPinned={isPinned} className='pointer' clickHandler={handlePinClick} loading={loading} />
      </div>
    </td>
  );
};

export default ActionsCell;
